"use client";

import * as React from "react";
import SidePanelMobile from "components/Explore/sidepanel/sidePanelMobile";

type ExploreMobileSidePanelV2Props = React.ComponentProps<typeof SidePanelMobile>;

/** Wrapper v2 del side panel mobile de Explore. */
export function ExploreMobileSidePanelV2(props: ExploreMobileSidePanelV2Props) {
  return <SidePanelMobile {...props} />;
}
